

import Debounce from 'vux/src/tools/debounce/index.js'
import Icon from 'vux/src/components/icon/index.vue'

import {uuid} from '@/utils/util.js'

export default {
name: 'VyInput',
components: {
Icon,
},
props: {
title: {type: String, default: ''},
type: {type: String, default: 'text'},
placeholder: String,
placeholderAlign: String,
value: [String, Number],
name: String,
required: Boolean,
readonly: Boolean,
inputDsiabled: Boolean,
disabled: Boolean,
keyboard: String,
isType: [String, Function],
min: Number,
max: Number,
showClear: {type: Boolean, default: true},
textAlign: String,
autocomplete: {type: String, default: 'off'},
autocapitalize: {type: String, default: 'off'},
autocorrect: {type: String, default: 'off'},
spellcheck: {type: String, default: 'false'},
debounce: {type: Number, default: 200},
labelWidth: String,
},
data () {
return {
uuid: uuid(),
hasRightFullHeightSlot: false,
hasRestrictedLabel: false,
forceShowError: false,
hasLengthEqual: false,
currentValue: this.value,
isFocus: false,
}
},
computed: {
labelStyles () {
return {
width:
this.labelWidthComputed ||
this.$parent.labelWidth ||
this.labelWidthComputed,
textAlign: this.$parent.labelAlign,
marginRight: this.$parent.labelMarginRight,
}
},
labelClass () {
return {
'vux-cell-justify':
this.$parent.labelAlign === 'justify' ||
this.$parent.$parent.labelAlign === 'justify',
}
},
pattern () {
if(this.keyboard === 'number' || this.isType === 'china-mobile') {
return '[0-9]*'
}
},
labelWidthComputed () {
const width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1
if(width < 10) {
return width + 'em'
}
},
inputStyle () {
if(this.textAlign) {
return {
textAlign: this.textAlign,
}
}
},
},
watch: {
value (val) {
this.currentValue = val
},
currentValue (newVal, oldVal) {
this.$emit('input', newVal)

if(this._debounce) {
this._debounce()
} else {
this.$emit('on-change', newVal)
}
},
},
created () {
/* istanbul ignore if */
if(process.env.NODE_ENV === 'development') {
if(!this.title && !this.placeholder && !this.currentValue) {
console.warn('no title and no placeholder?')
}
}
if(this.debounce) {
this._debounce = Debounce(() => {
this.$emit('on-change', this.currentValue)
}, this.debounce)
}
},
beforeMount () {
if(this.$slots && this.$slots['restricted-label']) {
this.hasRestrictedLabel = true
}
if(this.$slots && this.$slots['right-full-height']) {
this.hasRightFullHeightSlot = true
}
},
mounted () {
window.addEventListener('resize', this.scrollIntoView)
},
beforeDestroy () {
if(this._debounce) {
this._debounce.cancel()
}
window.removeEventListener('resize', this.scrollIntoView)
},
methods: {
scrollIntoView (time = 0) {

if(/iphone/i.test(navigator.userAgent)) {

}
},
reset (value) {
this.currentValue = value
},
clear () {
this.currentValue = ''
this.focus()
this.$emit('on-click-clear-icon')
},
focus () {
this.$refs.input.focus()
},
blur () {
this.$refs.input.blur()
},
onFocus ($event) {
this.$emit('on-focus', this.currentValue, $event)
this.isFocus = true

setTimeout(() => {
this.$refs.input.scrollIntoViewIfNeeded(false)

}, 1000)

},
onBlur ($event) {
this.isFocus = false
this.$emit('on-blur', this.currentValue, $event)
},
onKeyUp (e) {
if(e.key === 'Enter') {
e.target.blur()
this.$emit('on-enter', this.currentValue, e)
}
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInput.vue